import React from 'react';
import { getPassportRequestTypeLabelFromEnumKey } from '../constants/passportRequestType';

export default class PassportRequestTypeTransformer {
    transform(value) {
        // Sulu select fields may pass the full option object {name, value} instead of a plain string
        const type = (value !== null && typeof value === 'object') ? value.value : value;

        return (
            <span>{getPassportRequestTypeLabelFromEnumKey(type)}</span>
        );
    }
}
